import React from 'react'
import { Table, Loader } from '@web/walter-ui-kit'
import { Column } from '@web/walter-ui-kit/components/Table/types'

import styles from './style.module.css'
import { tableLang } from '~uikitLang'

const columns: Column[] = [
    {
        key: 'name',
        sortable: false,
        title: (
            <div className={styles.rowS}>
                <Loader />
            </div>
        ),
        width: '3.5fr',
        render: () => (
            <div className={styles.currency}>
                <div className={styles.currencyIcon}>
                    <Loader isCircled />
                </div>
                <div>
                    <div className={styles.currencyName}>
                        <Loader />
                    </div>
                    <div className={styles.currencyTicker}>
                        <Loader />
                    </div>
                </div>
            </div>
        ),
    },
    {
        key: 'price',
        title: (
            <div className={styles.rowS}>
                <Loader />
            </div>
        ),
        sortable: false,
        align: 'end',
        width: '1.2fr',
        render: () => (
            <div className={styles.priceCell}>
                <div className={styles.rowL}>
                    <Loader />
                </div>
                <div className={styles.rowS}>
                    <Loader />
                </div>
            </div>
        ),
    },
    {
        key: 'change',
        title: (
            <div className={styles.rowL}>
                <Loader />
            </div>
        ),
        sortable: false,
        align: 'end',
        width: '1.1fr',
        cellClassName: styles.hideMobile,
        render: () => (
            <div className={styles.rowM}>
                <Loader />
            </div>
        ),
    },
    {
        key: 'volume',
        title: (
            <div className={styles.rowL}>
                <Loader />
            </div>
        ),
        sortable: false,
        align: 'end',
        cellClassName: styles.hideMobile,
        render: () => (
            <div className={styles.rowM}>
                <Loader />
            </div>
        ),
    },
    {
        key: 'actions',
        sortable: false,
        cellClassName: styles.hideMobile,
        align: 'center',
        width: 88,
        render: () => (
            <div className={styles.action}>
                <Loader />
            </div>
        ),
    },
    {
        key: 'isFavorite',
        sortable: false,
        align: 'center',
        width: 48,
        render: () => (
            <div className={styles.iconFav}>
                <Loader />
            </div>
        ),
    },
]

export function TablePreloader() {
    return (
        <Table
            dataPointer="all_coins_preloader"
            columns={columns}
            data={new Array(10).fill('')}
            className={styles.table}
            locales={tableLang}
            transparent
        />
    )
}

function Preloader() {
    return <TablePreloader />
}

export default Preloader
